<template>
  <div v-if="!!phaseData">
    <field-label label="Desde quando está com sintomas?" class="mt-6">
      <template #label-extra>
        <info-btn @click="openDialog({ info: 'Considerar UCE somente em casos com mais de 6 semanas de sintomas.' })" />
      </template>
      <v-row>
        <v-col lg="3" md="12" sm="3">
          <v-menu
            ref="pickStartDate"
            v-model="pickStartDate"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="
                  phaseData.data_sintomas ? $moment(phaseData.data_sintomas).format('DD/MM/YYYY') : 'Data inicial'
                "
                solo
                v-bind="attrs"
                v-on="on"
                class="mt-3"
              />
            </template>
            <v-date-picker
              v-model="phaseData.data_sintomas"
              no-title
              @change="pickStartDate = false"
              locale="pt-br"
              :max="$moment().subtract(1, 'days').toISOString()"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </field-label>
    <div v-for="option in diagnosisOptions" :key="option.key">
      <field-label v-if="display(option)" :label="option.index + '. ' + option.text">
        <template #label-extra v-if="option.info">
          <info-btn @click="openDialog(option)" />
        </template>
        <radio-options
          v-if="!option.options"
          clearable
          v-model="phaseData[option.key]"
          :options="radioDefaultOptions"
          row
        />
        <div v-else>
          <radio-options clearable v-model="phaseData[option.key].value" :options="option.options.radios" row />
          <text-area
            v-if="phaseData[option.key]?.value === 'SIM' || phaseData[option.key]?.value === 'NEM_SEMPRE'"
            v-model="phaseData[option.key].info"
            :placeholder="option.options.textarea"
          />
        </div>
      </field-label>
    </div>
    <v-dialog v-model="showDialog" max-width="50vw" width="fit-content">
      <v-card>
        <v-card-title>
          {{ dialogData.title }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">{{ dialogData.text }}</v-col>
          </v-row>
          <v-row class="justify-center" v-if="dialogData.showImages">
            <v-col
              v-for="(image, index) in dialogData.images"
              :key="index + '_dialog_image'"
              class="d-flex flex-column"
              cols="4"
            >
              <v-img :src="image.src" :alt="image.title" max-width="250px" contain />
              <span>{{ image.title }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <field-label class="mt-8" label="Anotações">
      <text-area :readonly="disabled" :max-length="2000" v-model="phaseData.notes" />
    </field-label>
  </div>
</template>
<script>
import { DIAGNOSIS_OPTIONS } from '@/components/AttendanceForm/csu/constants/diagnosis'
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import FieldLabel from '@/components/FieldLabel.vue'
import InfoBtn from '@/components/InfoBtn.vue'
import RadioOptions from '@/components/RadioOptions.vue'
import TextArea from '@/components/TextArea.vue'
export default {
  components: { FieldLabel, InfoBtn, RadioOptions, TextArea },
  extends: BasePhase,
  data() {
    return {
      pickStartDate: false,
      showDialog: false,
      dialogData: {
        title: null,
        text: null,
        images: [],
        showImages: false,
      },
      diagnosisOptions: DIAGNOSIS_OPTIONS,
      radioDefaultOptions: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ],
    }
  },
  methods: {
    display(option) {
      if (!option.conditionToDisplay(this.phaseData)) {
        if (option.key == 'sintomas_induziveis') {
          this.phaseData[option.key].value = null
        } else {
          this.phaseData[option.key] = null
        }
      }
      return option.conditionToDisplay(this.phaseData)
    },
    getDefaultData() {
      const data = {
        data_sintomas: null,
        urticaria: null,
        angioedema: null,
        febre_dor_mal_estar: null,
        doenca_auto_inflamatoria: null,
        urticas_24_horas: null,
        vasculite_biopsia: null,
        sintomas_induziveis: {
          value: null,
          info: null,
        },
        teste_provocacao: null,
        ieca_bra_gliptinas: null,
        angioedema_deficiencia_c1: null,
        melhora_parar_ieca: null,
        notes: null,
      }
      return data
    },
    openDialog(data) {
      this.dialogData.text = data.info
      this.dialogData.title = data.text ?? null
      if (data.key === 'angioedema' || data.key === 'urticaria') {
        this.dialogData.showImages = true
        this.dialogData.images = data.images
      } else {
        this.dialogData.showImages = false
      }
      this.showDialog = true
    },
  },
}
</script>

<style scoped>
.info-dialog {
  background: white;
}
</style>
